import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersub } from "../../GenericComponent/HeaderSub/headersub";
import { TableDanhSach } from "./TableDanhSach";
import { SearchBarDesktop } from "./SearchBar/SearchBarDesktop";
import { SearchBarMobile } from "./SearchBar/SearchBarMobile";
import StoreApi from "service/phanQuyenApi";
import LayoutV2 from "containers/LayoutV2";

export const DanhSachThuBiXoa = () => {
  const initPhanQuyen = {
    danhsachthubixoa: false,
    danhsachthubixoa_xoaphieuthu: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenPhieuThuBiXoa().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        danhsachthubixoa: response.data.danhsachthubixoa,
        danhsachthubixoa_xoaphieuthu:
          response.data.danhsachthubixoa_xoaphieuthu,
      });
    });
  };

  useEffect(() => {
    document.title = "Danh sách thu bị xóa | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);
  return (
    <LayoutV2>
      {phanQuyen.danhsachthubixoa && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-thong-ke-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Danh sách thu bị xoá
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                    <SearchBarMobile />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableDanhSach quyenXoa={phanQuyen.danhsachthubixoa_xoaphieuthu} />
        </div>
      )}
      {!phanQuyen.danhsachthubixoa && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/icon-thong-ke-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">
                            Danh sách thu bị xoá
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
